import React from "react";

const Alert = (props) => {
  return (
    <div className="col-xl-12 col-xxl-12 col-lg-12">
      <div className="alert alert-danger left-icon-big alert-dismissible fade show">
        <button
          onClick={props.onClick}
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
        </button>
        <div className="media">
          <div className="alert-left-icon-big">
            <span>
              <i className="mdi mdi-alert"></i>
            </span>
          </div>
          <div className="media-body">
            <h5 className="mt-1 mb-2">{props.title}</h5>
            <p className="mb-0">{props.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alert;
